module.exports = __webpack_public_path__ + "static/media/App_en.308c15ae.png";